// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=\"%23999\" height=\"20\" viewBox=\"0 0 24 24\" width=\"20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container {
  position: relative;
  max-width: 100%;
  margin: 2.5rem;
  padding: 2.5rem 2rem;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.08), 0 1.5px 4px rgba(0,0,0,0.04);
}

.form-shell {
  position: relative;
}

.form-body--dimmed {
  opacity: 0.42;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  transition: opacity 0.22s ease;
}

.success-overlay {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.52);
  backdrop-filter: blur(2px);
  border-radius: 8px;
  box-sizing: border-box;
}

@supports not (backdrop-filter: blur(2px)) {
  .success-overlay {
    background: rgba(255, 255, 255, 0.72);
  }
}

.form-container form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2.2rem 2.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  font-size: 1.08rem;
  color: #222;
  font-weight: 600;
  margin-bottom: 0.2rem;
  letter-spacing: 0.01em;
  text-align: left;
  line-height: 1.2;
}

.required {
  color: #e53935;
  font-size: 1.1em;
  margin-left: 2px;
}

.form-group input,
.form-group select {
  height: 52px;
  min-height: 52px;
  max-height: 52px;
  padding: 0 1.2rem;
  font-size: 1.08rem;
  border: 1.5px solid #e0e0e0;
  border-radius: 8px;
  background: #fafbfc;
  color: #222;
  box-sizing: border-box;
  line-height: 2;
  display: block;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-group input[type="email"],
.form-group input[type="tel"],
.form-group input[type="text"] {
  height: 48px;
}

.form-group select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 1.2rem center;
  background-size: 1.2em;
  font-size: 1.08rem;
  line-height: 1.5;
  vertical-align: middle;
}

.form-group input::placeholder,
.form-group select:invalid {
  color: #b0b8c1;
  opacity: 1;
  font-size: 1.08rem;
}

.form-group input:focus,
.form-group select:focus {
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(74,144,226,0.12);
  background: #fff;
  color: #222;
}

.submit-button {
  grid-column: 1 / -1;
  width: 100%;
  padding: 1.2rem;
  background: linear-gradient(90deg, #e53935 0%, #b71c1c 100%);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 1.2rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  cursor: pointer;
  /* margin-top: 0.7rem;   */
  box-shadow: 0 2px 8px rgba(229,57,53,0.08);
  transition: background 0.2s, box-shadow 0.2s, transform 0.1s;
}

.submit-button:hover:not(:disabled) {
  background: linear-gradient(90deg, #b71c1c 0%, #e53935 100%);
  box-shadow: 0 4px 16px rgba(229,57,53,0.13);
  transform: translateY(-1px) scale(1.01);
}

.submit-button:disabled {
  opacity: 0.88;
  cursor: wait;
  transform: none;
}

.submit-button:disabled:hover {
  background: linear-gradient(90deg, #e53935 0%, #b71c1c 100%);
  box-shadow: 0 2px 8px rgba(229, 57, 53, 0.08);
  transform: none;
}

.error-text {
  color: #e53935;
  font-size: 0.97rem;
  margin-left: 2px;
  min-height: 20px;
  line-height: 1.2;
}

@media (max-width: 900px) {
  .form-container {
    padding: 1.5rem 0.5rem;
  }
  .form-container form {
    gap: 1.2rem 1rem;
  }
}

@media (max-width: 700px) {
  .form-container form {
    grid-template-columns: 1fr;
  }
  .form-group.full-width, .submit-button {
    grid-column: 1;
  }
}

.success-panel {
  width: 100%;
  max-width: 22rem;
  margin: 0;
}

.success-panel-inner {
  width: 100%;
  max-width: 22rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1.25rem 1.35rem 1.1rem;
  border-radius: 14px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: #fff;
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.06),
    0 8px 28px rgba(15, 23, 42, 0.08);
  box-sizing: border-box;
}

.success-icon {
  color: #16a34a;
  margin-bottom: 0.65rem;
  line-height: 0;
}

.success-message {
  margin: 0 0 1.05rem;
  font-size: 0.9375rem;
  line-height: 1.55;
  color: #334155;
  font-weight: 500;
  letter-spacing: -0.01em;
}

.success-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: center;
  width: 100%;
}

.success-btn {
  flex: 1 1 auto;
  min-width: 0;
  padding: 0.55rem 0.9rem;
  border-radius: 9px;
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: background 0.18s, box-shadow 0.18s, border-color 0.18s, color 0.18s, transform 0.12s;
}

.success-btn:active {
  transform: scale(0.98);
}

.success-btn-primary {
  background: linear-gradient(135deg, #e53935 0%, #c62828 100%);
  color: #fff;
  border: none;
  box-shadow: 0 1px 3px rgba(229, 57, 53, 0.25);
}

.success-btn-primary:hover {
  box-shadow: 0 4px 14px rgba(229, 57, 53, 0.28);
}

.success-btn-secondary {
  background: rgba(15, 23, 42, 0.04);
  color: #475569;
  border: 1px solid rgba(15, 23, 42, 0.1);
}

.success-btn-secondary:hover {
  background: rgba(15, 23, 42, 0.07);
  border-color: rgba(15, 23, 42, 0.14);
  color: #1e293b;
}

@media (max-width: 700px) {
  .success-panel-inner {
    max-width: min(22rem, 100%);
  }
}


.toast-notif {
  position: fixed;
  top: 32px;
  right: 32px;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-size: 1.08rem;
  font-weight: 600;
  box-shadow: 0 4px 24px rgba(67,160,71,0.13);
  z-index: 9999;
  animation: fadeInOut 2s;
}
.toast-notif.success {
  background: #43a047;
  color: #fff;
}
.toast-notif.error {
  background: #e53935;
  color: #fff;
}
@keyframes fadeInOut {
  0% { opacity: 0; transform: translateY(-20px);}
  10% { opacity: 1; transform: translateY(0);}
  90% { opacity: 1; }
  100% { opacity: 0; transform: translateY(-20px);}
}`, "",{"version":3,"sources":["webpack://./src/components/ContactForm.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,qEAAqE;AACvE;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,qCAAqC;EAErC,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,8CAA8C;AAChD;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,yDAAkL;EAClL,4BAA4B;EAC5B,wCAAwC;EACxC,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,2CAA2C;EAC3C,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,4DAA4D;EAC5D,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,0BAA0B;EAC1B,0CAA0C;EAC1C,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;EAC5D,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,4DAA4D;EAC5D,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB;;qCAEmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gGAAgG;AAClG;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;;AAGA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,KAAK,UAAU,EAAE,4BAA4B,CAAC;EAC9C,MAAM,UAAU,EAAE,wBAAwB,CAAC;EAC3C,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE,4BAA4B,CAAC;AAClD","sourcesContent":[".form-container {\n  position: relative;\n  max-width: 100%;\n  margin: 2.5rem;\n  padding: 2.5rem 2rem;\n  background: #fff;\n  border-radius: 14px;\n  box-shadow: 0 4px 24px rgba(0,0,0,0.08), 0 1.5px 4px rgba(0,0,0,0.04);\n}\n\n.form-shell {\n  position: relative;\n}\n\n.form-body--dimmed {\n  opacity: 0.42;\n  pointer-events: none;\n  user-select: none;\n  transition: opacity 0.22s ease;\n}\n\n.success-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 20;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba(255, 255, 255, 0.52);\n  -webkit-backdrop-filter: blur(2px);\n  backdrop-filter: blur(2px);\n  border-radius: 8px;\n  box-sizing: border-box;\n}\n\n@supports not (backdrop-filter: blur(2px)) {\n  .success-overlay {\n    background: rgba(255, 255, 255, 0.72);\n  }\n}\n\n.form-container form {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2.2rem 2.5rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.form-group.full-width {\n  grid-column: 1 / -1;\n}\n\n.form-group label {\n  font-size: 1.08rem;\n  color: #222;\n  font-weight: 600;\n  margin-bottom: 0.2rem;\n  letter-spacing: 0.01em;\n  text-align: left;\n  line-height: 1.2;\n}\n\n.required {\n  color: #e53935;\n  font-size: 1.1em;\n  margin-left: 2px;\n}\n\n.form-group input,\n.form-group select {\n  height: 52px;\n  min-height: 52px;\n  max-height: 52px;\n  padding: 0 1.2rem;\n  font-size: 1.08rem;\n  border: 1.5px solid #e0e0e0;\n  border-radius: 8px;\n  background: #fafbfc;\n  color: #222;\n  box-sizing: border-box;\n  line-height: 2;\n  display: block;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.form-group input[type=\"email\"],\n.form-group input[type=\"tel\"],\n.form-group input[type=\"text\"] {\n  height: 48px;\n}\n\n.form-group select {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-image: url('data:image/svg+xml;utf8,<svg fill=\"%23999\" height=\"20\" viewBox=\"0 0 24 24\" width=\"20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/></svg>');\n  background-repeat: no-repeat;\n  background-position: right 1.2rem center;\n  background-size: 1.2em;\n  font-size: 1.08rem;\n  line-height: 1.5;\n  vertical-align: middle;\n}\n\n.form-group input::placeholder,\n.form-group select:invalid {\n  color: #b0b8c1;\n  opacity: 1;\n  font-size: 1.08rem;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  border-color: #4a90e2;\n  box-shadow: 0 0 0 2px rgba(74,144,226,0.12);\n  background: #fff;\n  color: #222;\n}\n\n.submit-button {\n  grid-column: 1 / -1;\n  width: 100%;\n  padding: 1.2rem;\n  background: linear-gradient(90deg, #e53935 0%, #b71c1c 100%);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 1.2rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  cursor: pointer;\n  /* margin-top: 0.7rem;   */\n  box-shadow: 0 2px 8px rgba(229,57,53,0.08);\n  transition: background 0.2s, box-shadow 0.2s, transform 0.1s;\n}\n\n.submit-button:hover:not(:disabled) {\n  background: linear-gradient(90deg, #b71c1c 0%, #e53935 100%);\n  box-shadow: 0 4px 16px rgba(229,57,53,0.13);\n  transform: translateY(-1px) scale(1.01);\n}\n\n.submit-button:disabled {\n  opacity: 0.88;\n  cursor: wait;\n  transform: none;\n}\n\n.submit-button:disabled:hover {\n  background: linear-gradient(90deg, #e53935 0%, #b71c1c 100%);\n  box-shadow: 0 2px 8px rgba(229, 57, 53, 0.08);\n  transform: none;\n}\n\n.error-text {\n  color: #e53935;\n  font-size: 0.97rem;\n  margin-left: 2px;\n  min-height: 20px;\n  line-height: 1.2;\n}\n\n@media (max-width: 900px) {\n  .form-container {\n    padding: 1.5rem 0.5rem;\n  }\n  .form-container form {\n    gap: 1.2rem 1rem;\n  }\n}\n\n@media (max-width: 700px) {\n  .form-container form {\n    grid-template-columns: 1fr;\n  }\n  .form-group.full-width, .submit-button {\n    grid-column: 1;\n  }\n}\n\n.success-panel {\n  width: 100%;\n  max-width: 22rem;\n  margin: 0;\n}\n\n.success-panel-inner {\n  width: 100%;\n  max-width: 22rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 1.25rem 1.35rem 1.1rem;\n  border-radius: 14px;\n  border: 1px solid rgba(15, 23, 42, 0.08);\n  background: #fff;\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.06),\n    0 8px 28px rgba(15, 23, 42, 0.08);\n  box-sizing: border-box;\n}\n\n.success-icon {\n  color: #16a34a;\n  margin-bottom: 0.65rem;\n  line-height: 0;\n}\n\n.success-message {\n  margin: 0 0 1.05rem;\n  font-size: 0.9375rem;\n  line-height: 1.55;\n  color: #334155;\n  font-weight: 500;\n  letter-spacing: -0.01em;\n}\n\n.success-actions {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  justify-content: center;\n  width: 100%;\n}\n\n.success-btn {\n  flex: 1 1 auto;\n  min-width: 0;\n  padding: 0.55rem 0.9rem;\n  border-radius: 9px;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  transition: background 0.18s, box-shadow 0.18s, border-color 0.18s, color 0.18s, transform 0.12s;\n}\n\n.success-btn:active {\n  transform: scale(0.98);\n}\n\n.success-btn-primary {\n  background: linear-gradient(135deg, #e53935 0%, #c62828 100%);\n  color: #fff;\n  border: none;\n  box-shadow: 0 1px 3px rgba(229, 57, 53, 0.25);\n}\n\n.success-btn-primary:hover {\n  box-shadow: 0 4px 14px rgba(229, 57, 53, 0.28);\n}\n\n.success-btn-secondary {\n  background: rgba(15, 23, 42, 0.04);\n  color: #475569;\n  border: 1px solid rgba(15, 23, 42, 0.1);\n}\n\n.success-btn-secondary:hover {\n  background: rgba(15, 23, 42, 0.07);\n  border-color: rgba(15, 23, 42, 0.14);\n  color: #1e293b;\n}\n\n@media (max-width: 700px) {\n  .success-panel-inner {\n    max-width: min(22rem, 100%);\n  }\n}\n\n\n.toast-notif {\n  position: fixed;\n  top: 32px;\n  right: 32px;\n  padding: 1rem 2rem;\n  border-radius: 8px;\n  font-size: 1.08rem;\n  font-weight: 600;\n  box-shadow: 0 4px 24px rgba(67,160,71,0.13);\n  z-index: 9999;\n  animation: fadeInOut 2s;\n}\n.toast-notif.success {\n  background: #43a047;\n  color: #fff;\n}\n.toast-notif.error {\n  background: #e53935;\n  color: #fff;\n}\n@keyframes fadeInOut {\n  0% { opacity: 0; transform: translateY(-20px);}\n  10% { opacity: 1; transform: translateY(0);}\n  90% { opacity: 1; }\n  100% { opacity: 0; transform: translateY(-20px);}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
